// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul[data-v-6ea9d65d]{padding:0}li[data-v-6ea9d65d]{font-family:\"PP Woodland Regular\";display:inline-block;list-style:none;margin-right:0.5rem;font-size:1rem;line-height:1rem;color:#2c94fc}", ""]);
// Exports
module.exports = exports;
